
import { useEffect, useState } from "react"
import styles from "../css/Transacciones.module.css"
import miAxios from "../api/axios"
import { useAuth } from "../hooks/AuthProvider"
import { IconButton, TextField, FormControlLabel, Switch } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import Confirmacion from "../components/Conformacion"
import EditIcon from '@mui/icons-material/Edit';
import PideValor from "../components/PideValor"
import Wait from "../components/Wait"

const soloNumeros = (texto) => {
    let nums = "0123456789."
    let res = ""
    for (var i = 0; i < texto.length; i++) {
        let s = texto[i]
        if (nums.indexOf(s) > -1) {
            res = res + s
        }
    }
    return res;
}

const getInicio = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-01-' + dd;
    return today;
}

const getHoy = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-' + mm + '-' + dd;
    return today;
}

export default function Transacciones(props) {
    const [rows, setRows] = useState([])
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [openConfirmacion, setOpenConfirmacion] = useState({ open: false, id: 0 })
    const [desde, setDesde] = useState(getInicio())
    const [hasta, setHasta] = useState(getHoy())
    const [incluyeInactivos, setIncluyeInactivos] = useState(false)
    const [openPideValor, setOpenPideValor] = useState({open: false, id: 0})

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        actRows()
    }, [])

    useEffect(() => {
        actRows()
    }, [desde, hasta, incluyeInactivos])

    const actRows = async () => {
        setProcesando(true)

        try {
            const response = await axios.get("/despachos/historico?desde=" + desde + "&hasta=" + hasta + "&incluye_inactivos=" + incluyeInactivos)

            const data = response.data;
            if (data.respuesta == "S") {
                setRows(data.lista)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleImprimir = (cual) => {
        window.open("/reportes/facturar?id=" + cual, "_blank")
    }

    const anular = async (cual) => {
        setOpenConfirmacion({
            open: false,
            id: 0
        })
        setProcesando(true)

        try {
            const response = await axios.post("/despachos/anular?cual=" + cual)

            const data = response.data;
            if (data.respuesta == "S") {
                actRows()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleAnular = () => {
        /* const n = rows.filter((r) => r.id == openConfirmacion.id)
        if (n[0].estatus != "Despachado") {
            setMensaje("Estatus incorrecto!")
            return;
        } */
        anular(openConfirmacion.id)

    }

    const handleCambiarFactura = async (factura)=>{
        if (!factura){
            setMensaje("Debe introducir un numero de factura")
            return;
        }
        const idDespacho = openPideValor.id 
        setOpenPideValor({
            open: false,
            id: 0
        })
        setProcesando(true)

        try {
            const response = await axios.post("/despachos/cambia-factura?id=" + idDespacho + "&factura=" + factura)

            const data = response.data;
            if (data.respuesta == "S") {
                actRows()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const getFactura = (id)=>{
        let resultado = ""
        const n = rows.filter((row)=>row.id==id)[0]
        if (n){
            resultado = n.factura
        }
        return resultado
    }

    return <div className={styles.cuerpo}>
        {
            procesando && (
                <Wait procesando={procesando} />
            )
        }
        {
            openConfirmacion.open && (
                <Confirmacion open={openConfirmacion.open} texto="¿Desea ANULAR este despacho?" exito={() => { handleAnular() }} cancelar={() => { setOpenConfirmacion({ open: false, id: 0 }) }} />
            )
        }
        {
            openPideValor.open && (
                <PideValor
                    open={openPideValor.open}
                    texto="Digite número de factura"
                    cerrar={()=>{setOpenPideValor({open: false, id: 0})}}
                    exito={(valor)=>{handleCambiarFactura(valor)}}
                    valor={getFactura(openPideValor.id)}
                />
            )
        }
        <div className={styles.header}>
            Histórico Ordenes Despachadas
        </div>
        <div className={styles.filtro}>
            <div>
                <TextField
                    value={desde}
                    label="Desde"
                    type="date"
                    size="small"
                    color="coopinfa"
                    onChange={(event) => { setDesde(event.target.value) }}
                />
            </div>
            <div>
                <TextField
                    value={hasta}
                    label="Hasta"
                    type="date"
                    size="small"
                    color="coopinfa"
                    onChange={(event) => { setHasta(event.target.value) }}
                />
            </div>
            <div>
                <FormControlLabel
                    control={<Switch size="small" checked={incluyeInactivos}
                        color="coopinfa"
                        onChange={(event) => { setIncluyeInactivos(event.target.checked) }} />}
                    label="Incluir inactivos"
                />
            </div>
        </div>
        <div className={styles.tabla}>
            <table width={"100%"}>
                <thead>
                    <tr className={styles.rows}>
                        <th>Tr. #</th>
                        <th>Factura</th>
                        <th>Estatus</th>
                        <th>Fecha</th>
                        <th>Cédula</th>
                        <th>Nombre</th>
                        <th>Monto</th>
                        <th>Orden #</th>
                        <th>Orden Fecha</th>
                        <th>Re-imprimir</th>
                        <th>Inactivar</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rows.map((row) => {
                            return <tr className={styles.rows} key={row.id}>
                                <td>{row.numero}</td>
                                <td>
                                    <IconButton size="small" onClick={()=>{setOpenPideValor({open: true, id: row.id})}}>
                                        <EditIcon />
                                    </IconButton>
                                    {row.factura}
                                </td>
                                <td>{row.estatus}</td>
                                <td>{row.fecha}</td>
                                <td>{row.cedula}</td>
                                <td>{row.nombre}</td>
                                <td>
                                    {parseFloat(row.monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </td>
                                <td>{row.orden}</td>
                                <td>{row.orden_fecha}</td>
                                <td style={{ textAlign: "center" }}>
                                    {parseInt(row.web2) != 0 && (<IconButton onClick={() => { handleImprimir(row.token) }}>
                                        <PrintIcon />
                                    </IconButton>)}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {parseInt(row.id_estatus) == 1 && (<IconButton onClick={() => {
                                        setOpenConfirmacion({
                                            open: true, id: row.id
                                        })
                                    }}>
                                        <DeleteIcon />
                                    </IconButton>)}
                                </td>
                            </tr>
                        })
                    }
                </tbody>
            </table>
        </div>
    </div>
}